<template>
    <Content :length="result.length > 3 ? 3 : result.length" >
        <div v-if="result.length" >
            <h2 v-if="result.length > 1">
                Aqui estão os resultados que mais combinam com suas respostas.<br>
                Fique a vontade para escolher os de sua preferência!
            </h2>
            <div class="section-products">
                <template v-for="(r, idx) in result">
                    <ProductResult :key="idx" :product="r" />
                </template>
            </div>
        </div>
        <template v-else>
            <p class="no-suggestions">
                Não foram encontradas sugestões para a combinação de respostas
                informadas.<br />
                Consulte nossos produtos e fique a vontade para escolher o de
                sua preferência!
            </p>
        </template>
        <PrimaryButton type="button" @click.prevent="backToQuizPage">
            Fazer novamente
        </PrimaryButton>
    </Content>
</template>

<script>
import { mapActions } from "vuex";
import { PrimaryButton } from "../../../components/Styles/Extends/styled";
import { swall } from "../../../services/sweetAlert";
import { Content } from "./style";
import ProductResult from "../ProductResult";

export default {
    name: "QuizResultPage",
    props: {
        quiz: {
            required: true
        }
    },
    components: {
        Content,
        PrimaryButton,
        ProductResult
    },
    data() {
        return {
            result: []
        };
    },
    mounted() {
        this.getByQuizId();
    },
    methods: {
        ...mapActions("quizzes", ["ActionGetByQuizId"]),
        getByQuizId() {
            this.ActionGetByQuizId(this.quiz.id)
                .then(response => {
                    this.result = response.data ?? [];
                })
                .catch(error => {
                    swall(error?.msg ?? error?.message ?? error);
                });
        },
        goToLink() {
            window.location.href = this.result.url_redirect;
        },
        backToQuizPage() {
            window.location.href = `${this.$baseUrl}questionarios/${this.quiz.slug}`;
        }
    },
};
</script>
